import * as angular from 'angular';
import { config, reactShell } from 'angular/utils/config';

type RootData = {
    _links?: {
        [key: string]: {
            href: string;
        };
    };
};

type PhoneNumber = {
    countryCallingCode: string;
    subscriber: string;
};

type Address = {
    companyName: string;
    addressLine1: string;
    addressLine2: string | undefined;
    postCode: string;
    city: string;
    country: string;
};

type OrganisationData = {
    organisationId: string;
    organisationEic: string | undefined;
    companyName: string;
    organisationVat: string | undefined;
    phone: PhoneNumber | undefined;
    email: string;
    registeredAddress: Address;
    createdAt: string | undefined;
    changedAt: string | undefined;
};

export class OrganisationService {
    public accessible = false;

    private resolveData;
    public data = new Promise<RootData | null>(
        (resolve) => (this.resolveData = resolve)
    );

    constructor() {
        this.init();
    }

    private async init() {
        if (!config.organisationService) {
            this.resolveData(null);
            return;
        }

        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);
            const response = await reactShell.axios.request({
                url: config.organisationService,
                signal: controller.signal
            });
            clearTimeout(timeoutId);

            this.resolveData(response.data);
            this.accessible = Boolean(response.data._links);
        } catch (e) {
            this.resolveData(null);

            if (
                e &&
                e.name === 'AxiosError' &&
                e.response &&
                (e.response.status === 401 || e.response.status === 403)
            )
                return;
            console.error(e);
        }
    }

    public async getMyOrganisationDetails() {
        const rootData = await this.data;
        if (
            rootData &&
            rootData._links &&
            rootData._links.getMyOrganisationDetails
        ) {
            try {
                const response =
                    await reactShell.axios.request<OrganisationData>({
                        url: rootData._links.getMyOrganisationDetails.href
                    });
                return response.data;
            } catch (e) {
                if (
                    e &&
                    e.name === 'AxiosError' &&
                    e.response &&
                    (e.response.status === 401 || e.response.status === 403)
                )
                    return;
                console.error(e);
            }
        } else {
            console.error('Could not load my organisation details');
            return;
        }
    }
}

angular.module('app').service('organisationService', OrganisationService);
